import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { createFaq, deleteFaq, getFaqs, updateFaq } from '../api/react/FAQ/faq'
import { useAuth } from './useAuth'
import type { CreateFaqRequest, UpdateFaqRequest } from '../types/faq.types'

export const FAQ_KEYS = {
  list: () => ['faq'] as const,
}

export const useFaqs = () => {
  const { user } = useAuth()
  return useQuery({
    queryKey: FAQ_KEYS.list(),
    queryFn: getFaqs,
    enabled: !!user,
  })
}

export const useCreateFaq = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateFaqRequest) => createFaq(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: FAQ_KEYS.list() }),
  })
}

export const useUpdateFaq = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateFaqRequest) => updateFaq(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: FAQ_KEYS.list() }),
  })
}

export const useDeleteFaq = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteFaq(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: FAQ_KEYS.list() }),
  })
}
